export default __webpack_public_path__ + "static/media/Myriad.9adc1136.jpg";